import React from "react";
import { Box, Switch, Typography } from "@mui/joy";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import moment, { Moment } from "moment";

export interface DayValues {
    isEnabled: boolean;
    from: string;
    to: string;
}

interface Props {
    label: string;
    value: DayValues;
    disabled: boolean;
    onChange: (next: DayValues) => void;
}

const TIME_FORMAT = "HH:mm";

const parseTime = (v: string): Moment | null => {
    const m = moment(v, TIME_FORMAT, true);
    return m.isValid() ? m : null;
};

const ScheduleDayRow = ({ label, value, disabled, onChange }: Props) => {
    const dayDisabled = disabled || !value.isEnabled;

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 1 }}>
            <Box sx={{ width: 130, display: "flex", alignItems: "center", gap: 1 }}>
                <Switch
                    checked={value.isEnabled}
                    onChange={(e) => onChange({ ...value, isEnabled: e.target.checked })}
                    disabled={disabled}
                />
                <Typography level="body-md" sx={{ color: dayDisabled ? "neutral.400" : undefined }}>
                    {label}
                </Typography>
            </Box>
            <TimePicker
                ampm={false}
                value={parseTime(value.from)}
                onChange={(next) => onChange({ ...value, from: next?.format(TIME_FORMAT) ?? "" })}
                disabled={dayDisabled}
                slotProps={{ textField: { size: "small", sx: { width: 120 } } }}
            />
            <Typography level="body-md" sx={{ color: dayDisabled ? "neutral.400" : undefined }}>
                –
            </Typography>
            <TimePicker
                ampm={false}
                value={parseTime(value.to)}
                onChange={(next) => onChange({ ...value, to: next?.format(TIME_FORMAT) ?? "" })}
                disabled={dayDisabled}
                slotProps={{ textField: { size: "small", sx: { width: 120 } } }}
            />
        </Box>
    );
};

export default ScheduleDayRow;
